<ion-header class="toolbar-roxa">
  <ion-toolbar>
    <ion-buttons class="pencil" slot="start">
      <ion-button color="primary" (click)="voltar()">
        voltar
      </ion-button>
    </ion-buttons>
    <ion-title>Editar</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <section class="section-cabecalho ion-hide-md-down">
    <div class="cabecalho-acoes">
      <ion-button class="editar" fill="clear" routerLink="/painel">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </div>
  </section>
  <section class="section-conteudo">
    <article class="article-conteudo">
      <ion-list>
        <ion-list-header>
          ESTAÇÃO PRINCIPAL
        </ion-list-header>

        <div cdkDropList class="estacao-list" *ngIf="estacaoPrincipal">
          <div class="estacao-box">
            <div class="acoes">
              <ion-button fill="clear" (click)="confirmRemoverFavorito(estacaoPrincipal)">
                <ion-icon name="lixeira" slot="icon-only" color="danger"></ion-icon>
              </ion-button>
            </div>
            <div class="div-centro">
              <h6>{{estacaoPrincipal?.noEstacao}}</h6>
              <p *ngIf="estacaoPrincipal && estacaoPrincipal.municipio">{{estacaoPrincipal?.municipio?.noMunicipio + '-' + estacaoPrincipal?.municipio?.uf?.sgUf}}</p>
            </div>
          </div>
        </div>

        <div class="estacao-list" *ngIf="!estacaoPrincipal">
          <div class="estacao-box" (click)="buscarFavorito(true)">
            <div class="acoes">
              <ion-button fill="clear">
                <ion-icon name="soma-outline" slot="icon-only"></ion-icon>
              </ion-button>
            </div>
            <div class="div-centro">
              <h6>Sem estação principal</h6>
              <p>Adicionar estação principal </p>
            </div>
          </div>
        </div>

      </ion-list>
      <ion-list>
        <ion-list-header>
          ESTAÇÕES FAVORITAS
          <ion-button *ngIf="estacoesFavoritas.length" (click)="buscarFavorito()" fill="clear">
            <ion-icon name="soma-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-list-header>

        <div class="estacao-list" *ngIf="!estacoesFavoritas.length">
          <div class="estacao-box" (click)="buscarFavorito()">
            <div class="acoes">
              <ion-button fill="clear">
                <ion-icon name="soma-outline" slot="icon-only"></ion-icon>
              </ion-button>
            </div>
            <div class="div-centro">
              <h6>Sem estações favoritas</h6>
              <p>Adicionar estação favorita</p>
            </div>
          </div>
        </div>

        <div cdkDropList class="estacao-list" (cdkDropListDropped)="drop($event)">
          <div class="estacao-box" *ngFor="let estacao of estacoesFavoritas" cdkDrag>
            <div class="estacao-custom-placeholder" *cdkDragPlaceholder></div>
            <div class="acoes">
              <ion-button fill="clear" (click)="confirmRemoverFavorito(estacao)">
                <ion-icon name="lixeira" slot="icon-only" color="danger"></ion-icon>
              </ion-button>
            </div>
            <div class="div-centro">
              <h6>{{estacao?.noEstacao}}</h6>
              <p *ngIf="estacao && estacao.municipio">{{estacao?.municipio?.noMunicipio + '-' + estacao?.municipio?.uf?.sgUf}}</p>
            </div>
            <div class="acoes mover" cdkDragHandle>
              <ion-icon name="menu" color="primary" slot="icon-only"></ion-icon>
            </div>
          </div>
        </div>


      </ion-list>
    </article>
  </section>
</ion-content>
